import { render, staticRenderFns } from "./codePay.vue?vue&type=template&id=bb351394&scoped=true&"
import script from "./codePay.vue?vue&type=script&lang=js&"
export * from "./codePay.vue?vue&type=script&lang=js&"
import style0 from "./codePay.vue?vue&type=style&index=0&id=bb351394&prod&ref=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb351394",
  null
  
)

export default component.exports